<template>
    <div class="contentBox">
        <div class="contentHeader">
            <div>
                <el-form :inline="true" ref="form" label-width="90px">
                    <el-row>
                        <el-col :span="3">
                            <el-button size="mini" @click="dialogEditAppVisible=true">添加</el-button>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item size="mini" label="环境：">
                                <el-select v-model="env" filterable placeholder="请选择">
                                    <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item size="mini" label="应用名称：">
                                <el-input v-model="appName" placeholder="请输入应用名称搜索"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="contentBody">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="名称" prop="name" align="center">
                </el-table-column>
                <el-table-column label="code" prop="code" align="center">
                </el-table-column>
                <el-table-column label="描述" prop="description" align="center">
                </el-table-column>
                <el-table-column label="类型" prop="appType" align="center">
                </el-table-column>
                <el-table-column label="协议" prop="protocol" align="center">
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="tableDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    :total="total"
                    :current-page="pageNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <el-drawer :title="dialogEditAppData.id === '' ? '新增应用' : '编辑应用'"
                   :center="true" :visible.sync="dialogEditAppVisible" :close-on-click-modal="false"
                   :wrapperClosable="false" @closed="dialogEditAppClosedFn" size="70%">
            <el-form :model="dialogEditAppData">
                <el-form-item label="应用名称: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.name" autocomplete="off" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="code: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.code" autocomplete="off"
                              :disabled="dialogEditAppData.id !== ''" placeholder="请输入应用code"></el-input>
                </el-form-item>
                <el-form-item label="描述: " :label-width="formLabelWidth">
                    <el-input type="textarea" autosize v-model="dialogEditAppData.description" autocomplete="off"
                              placeholder="请输入应用描述"></el-input>
                </el-form-item>
                <el-form-item label="logo: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.logoUrl" autocomplete="off" placeholder="请输入应用logo"></el-input>
                </el-form-item>
                <el-form-item label="范围: " :label-width="formLabelWidth">
                    <el-select v-model="dialogEditAppData.scope" placeholder="请选择">
                        <el-option v-for="item in scopeOptions"
                                   :key="item.value"
                                   :label="item.value"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="dialogEditAppData.scope" autocomplete="off" placeholder="请输入应用查看范围"></el-input> -->
                </el-form-item>
                <el-form-item label="状态: " :label-width="formLabelWidth">
                    <el-select v-model="dialogEditAppData.status" placeholder="请选择">
                        <el-option v-for="item in statusOptions"
                                   :key="item.value"
                                   :label="item.value"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="dialogEditAppData.status" autocomplete="off" placeholder="请输入应用状态"></el-input> -->
                </el-form-item>
                <el-form-item label="应用类型: " :label-width="formLabelWidth">
                    <el-select v-model="dialogEditAppData.appType" placeholder="请选择">
                        <el-option v-for="item in appTypeOptions"
                                   :key="item.value"
                                   :label="item.value"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="dialogEditAppData.appType" autocomplete="off" placeholder="请输入应用类型"></el-input> -->
                </el-form-item>
                <el-form-item label="租户id: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.tenantId" autocomplete="off" placeholder="请输入租户id"></el-input>
                </el-form-item>
                <el-form-item label="类型集合: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.types" autocomplete="off"
                              placeholder="请输入应用类型集合','分割"></el-input>
                </el-form-item>
                <el-form-item label="应用协议: " :label-width="formLabelWidth">
                    <el-select v-model="dialogEditAppData.protocol" placeholder="请选择">
                        <el-option v-for="item in appProtocolOptions"
                                   :key="item.value"
                                   :label="item.value"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="dialogEditAppData.protocol" autocomplete="off" placeholder="请输入应用登录协议"></el-input> -->
                </el-form-item>
                <el-form-item label="配置: " :label-width="formLabelWidth">
                    <el-input type="textarea" autosize v-model="dialogEditAppData.config" autocomplete="off"
                              placeholder="请输入应用配置JSON"></el-input>
                </el-form-item>
                <el-form-item label="动态表单: " :label-width="formLabelWidth">
                    <el-input type="textarea" autosize v-model="dialogEditAppData.dynamicForm" autocomplete="off"
                              placeholder="请输入动态表单JSON"></el-input>
                </el-form-item>
                <el-form-item label="版本号: " :label-width="formLabelWidth">
                    <el-input v-model="dialogEditAppData.version" autocomplete="off" placeholder="请输入版本号"></el-input>
                </el-form-item>
                <el-form-item label="是否idp启动: " :label-width="formLabelWidth">
                    <el-select v-model="dialogEditAppData.isIdpInitiated" placeholder="请选择">
                        <el-option v-for="item in isIdpInitiatedOptions"
                                   :key="item.value"
                                   :label="item.value"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="dialogEditAppData.isIdpInitiated" autocomplete="off" placeholder="请输入true或者false"></el-input> -->
                </el-form-item>
                <el-form-item label="同步配置: " :label-width="formLabelWidth">
                    <el-input type="textarea" autosize v-model="dialogEditAppData.syncConfig" autocomplete="off"
                              placeholder="请输入应用同步配置JSON"></el-input>
                </el-form-item>
            </el-form>
            <div class="demo-drawer__footer">
                <el-button @click="dialogEditAppVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmButton()">确 定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        data: () => {
            return {
                tableData: [], // 表格内容
                pageSizes: [10, 20, 50, 100],
                pageSize: 10, //每页条数
                pageNumber: 1, //页码
                total: 0, // 总页数
                appTypeOptions: [], // 应用类型下拉选内容
                protocolTypeOptions: [], // 协议类型下拉选内容
                dialogEditAppVisible: false, // 默认关闭弹窗
                dialogEditAppData: { // 编辑弹窗数据
                    id: '', // 用于判断是新增还是编辑
                    name: '', // 应用名称
                    code: '', // code
                    description: '', // 描述
                    logoUrl: '', // logo地址
                    scope: '', // 范围
                    status: '', // 是否启用
                    appType: '', // 应用类型
                    types: '', // 类型
                    protocol: '', //登录协议
                    tenantId: '', // 租户id
                    config: '', // 配置
                    dynamicForm: '',
                    version: '',
                    isIdpInitiated: '', //是否是idp启动
                    syncConfig: '' // 同步配置
                },
                formLabelWidth: '120px', // 抽屉的文字宽度
                scopeOptions: [], // 范围下拉选选择框
                statusOptions: [], // 状态下拉选选择框
                appTypeOptions: [], // app类型下拉选选择框
                appProtocolOptions: [], // app协议下拉选选择框
                isIdpInitiatedOptions: [], // 是否idp启动下拉选
                value: '',
                appName: '',
                envOptions: [],
                env: '',
            }
        },
        // 打开页面加载的组件
        mounted: function () {
            this.getEnvOptions();
            if (this.env !== '') {
                this.getTableData(); // 获取表格数据
            }
            this.getOptions(); // 获取下拉选
        },
        // 监听事件
        watch: {
            appName() { // 监听搜索名称输入框发生了变化
                this.getTableData(); // 发生变化进行更新表格
            },
            env() {
                this.getTableData();
            }
        },
        // 方法
        methods: {
            // 获取表格数据方法
            getTableData: function () {
                const self = this;
                let params = {};
                params.pageNum = self.pageNumber - 1; //第几页
                params.pageSize = self.pageSize; //每页数量
                params.appName = self.appName; // app名字
                params.env = self.env;
                self.$axios_api.getAppList(params).then(res => {
                    // 更新表格
                    self.tableData = res.rows;
                    //更新分页总条数
                    self.total = res.total;
                });
            },
            // 获取下拉选
            getOptions: function () {
                this.appTypeOptions = [ // app类型下拉选选择框
                    {
                        value: 'APP'
                    },
                    {
                        value: 'DIRECTORY'
                    },
                    {
                        value: 'APP_CUSTOM'
                    },
                    {
                        value: 'IDENTITY'
                    },
                    {
                        value: 'IDENTITY_CUSTOM'
                    },
                    {
                        value: 'WORKBENCH'
                    },
                    {
                        value: 'APP_DIRECT'
                    }
                ],
                    this.statusOptions = [ // 状态下拉选选择框
                        {
                            value: 'ACTIVE'
                        },
                        {
                            value: 'DEACTIVE'
                        }
                    ],
                    this.scopeOptions = [ // 范围下拉选选择框
                        {
                            value: 'PRIVATE'
                        },
                        {
                            value: 'PUBLIC'
                        },
                        {
                            value: 'YUFU'
                        }
                    ],
                    this.appProtocolOptions = [ // app协议下拉选选择框
                        {
                            value: 'OIDC'
                        },
                        {
                            value: 'SDK'
                        },
                        {
                            value: 'STANDARD_OIDC'
                        },
                        {
                            value: 'SAML11'
                        },
                        {
                            value: 'SAML20'
                        },
                        {
                            value: 'WS_FED'
                        },
                        {
                            value: 'CUSTOM'
                        },
                        {
                            value: 'BOOKMARK'
                        },
                        {
                            value: 'CAS'
                        },
                        {
                            value: 'FORM_POST'
                        },
                        {
                            value: 'CS_FORM_POST'
                        },
                        {
                            value: 'FORM_POST_PLUGIN'
                        },
                    ],
                    this.isIdpInitiatedOptions = [ // 是否idp启动下拉选
                        {
                            value: 'true'
                        },
                        {
                            value: 'false'
                        }
                    ]
            },
            //分页页码变化
            handleCurrentChange: function (pageNum) {
                this.pageNumber = pageNum;
                this.getTableData(); //获取对应页码的数据
            },
            handleSizeChange: function (pageSize) {
                this.pageSize = pageSize;
                this.getTableData();
            },
            // 表格编辑按钮
            handleEdit: function (row) {
                const self = this;
                let params = {};
                params.env = self.env;
                params.code = row.code;
                self.dialogEditAppData.id = row.id;
                self.dialogEditAppData.name = row.name;
                self.dialogEditAppData.code = row.code;
                self.dialogEditAppData.description = row.description;
                self.dialogEditAppData.logoUrl = row.logoUrl;
                self.dialogEditAppData.scope = row.scope;
                self.dialogEditAppData.status = row.status;
                self.dialogEditAppData.appType = row.appType;
                self.dialogEditAppData.types = row.types.join(',');
                self.dialogEditAppData.protocol = row.protocol;
                self.dialogEditAppData.tenantId = row.tenantId;
                self.dialogEditAppData.isIdpInitiated = row.isIdpInitiated != null ? row.isIdpInitiated.toString() : null;
                if (row.config !== '' && row.config != null) {
                    self.dialogEditAppData.config = JSON.stringify(row.config, null, 4);
                }
                if (row.syncConfig !== '' && row.syncConfig != null) {
                    self.dialogEditAppData.syncConfig = JSON.stringify(row.syncConfig, null, 4);
                }
                if (row.code !== '' && row.code != null) {
                    self.$axios_api.getApp(params).then(res => {
                        if (res.dynamicForm !== '' && res.dynamicForm !== null) {
                            self.dialogEditAppData.dynamicForm = JSON.stringify(res.dynamicForm, null, 4);
                        }
                        self.dialogEditAppData.version = res.version;
                    });
                }
                self.dialogEditAppVisible = true;
            },
            // 表格删除按钮
            tableDelete: function (row) {
                const self = this;
                self.$confirm('此操作将删除该条数据，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        self.deleteApp(row);
                    })
                    .catch(() => {
                    });
            },
            // 新增app或者编辑app按钮
            confirmButton: function () {
                const self = this;
                if (self.dialogEditAppData.name === '') {
                    self.$message({
                        message: '应用名称不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.code === '') {
                    self.$message({
                        message: '应用code不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.scope === '') {
                    self.$message({
                        message: '范围不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.status === '') {
                    self.$message({
                        message: '状态不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.appType === '') {
                    self.$message({
                        message: '应用类型不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.protocol === '') {
                    self.$message({
                        message: '登录协议不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.isIdpInitiated === '') {
                    self.$message({
                        message: '是否idp启动不能为空',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.config !== '' && !self.isJsonString(self.dialogEditAppData.config)) {
                    self.$message({
                        message: '所输入的配置不是json字符串',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.dynamicForm !== '' && !self.isJsonString(self.dialogEditAppData.dynamicForm)) {
                    self.$message({
                        message: '所输入的动态表单不是json字符串',
                        type: 'warning'
                    })
                } else if (self.dialogEditAppData.syncConfig !== '' && !self.isJsonString(self.dialogEditAppData.syncConfig)) {
                    self.$message({
                        message: '所输入的同步配置不是json字符串',
                        type: 'warning'
                    })
                } else {
                    self.editOrSaveAppFn();
                }
            },
            // 新增或者保存app方法
            editOrSaveAppFn: function () {
                const self = this;
                let params = {};
                params.id = self.dialogEditAppData.id;
                params.name = self.dialogEditAppData.name;
                params.code = self.dialogEditAppData.code;
                params.description = self.dialogEditAppData.description;
                params.logoUrl = self.dialogEditAppData.logoUrl;
                params.scope = self.dialogEditAppData.scope;
                params.status = self.dialogEditAppData.status;
                params.appType = self.dialogEditAppData.appType;
                params.protocol = self.dialogEditAppData.protocol;
                params.tenantId = self.dialogEditAppData.tenantId;
                params.isIdpInitiated = self.dialogEditAppData.isIdpInitiated === 'true';
                let types = self.dialogEditAppData.types; // 获取应用类型集合
                params.types = types.split(',');
                params.isIdpInitiated = JSON.parse(self.dialogEditAppData.isIdpInitiated); // 字符串转boolean
                if (params.tenantId === '') { // 判断租户id等不等于空
                    params.tenantId = null;
                }
                if (self.dialogEditAppData.config === '') { // 判断配置等不等于空
                    params.config = null;
                }
                if (self.dialogEditAppData.dynamicForm === '') {
                    params.dynamicForm = null;
                }
                if (self.dialogEditAppData.syncConfig === '') { // 判断同步配置等不等于空
                    params.syncConfig = null;
                }
                if (self.dialogEditAppData.config !== '') { // 配置不等于空转换为json
                    params.config = JSON.parse(self.dialogEditAppData.config);
                }
                if (self.dialogEditAppData.dynamicForm !== '') {
                    params.dynamicForm = JSON.parse(self.dialogEditAppData.dynamicForm);
                }
                if (self.dialogEditAppData.syncConfig !== '') { // 同步配置不等于空转换为json
                    params.syncConfig = JSON.parse(self.dialogEditAppData.syncConfig);
                }
                let data = JSON.stringify(params);
                if (self.dialogEditAppData.id === '') { // id为空新增，否则编辑
                    self.$axios_api.saveApp(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditAppVisible = false;
                        self.getTableData();
                    })
                } else {
                    self.$axios_api.updateApp(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditAppVisible = false;
                        self.getTableData();
                    })
                }
            },
            // 删除app事件
            deleteApp: function (row) {
                const self = this;
                let params = {};
                params.code = row.code;
                self.$axios_api.deleteApp(params).then(res => {
                    self.$message({
                        message: res,
                        type: 'success'
                    });
                    self.getTableData(); //更新表格当前页数据
                });
            },
            // 弹窗关闭按钮
            dialogEditAppClosedFn: function () {
                this.dialogEditAppData.id = '';
                this.dialogEditAppData.name = '';
                this.dialogEditAppData.code = '';
                this.dialogEditAppData.description = '';
                this.dialogEditAppData.logoUrl = '';
                this.dialogEditAppData.scope = '';
                this.dialogEditAppData.status = '';
                this.dialogEditAppData.appType = '';
                this.dialogEditAppData.types = '';
                this.dialogEditAppData.protocol = '';
                this.dialogEditAppData.tenantId = '';
                this.dialogEditAppData.config = '';
                this.dialogEditAppData.dynamicForm = '';
                this.dialogEditAppData.isIdpInitiated = '';
                this.dialogEditAppData.syncConfig = '';
            },
            // 判断是不是json
            isJsonString: function (str) {
                try {
                    if (typeof JSON.parse(str) == "object") {
                        return true;
                    }
                } catch (e) {
                }
                return false;
            },
            getEnvOptions() {
                const self = this;
                let params = {};
                self.$axios_api.getEnvOptions(params).then(res => {
                    self.env = res.env_options[0].value;
                    self.envOptions = res.env_options;
                });
            },
        }
    };
</script>

<style>
    /*.contentBox {*/
    /*	margin-top: 60px;*/
    /*}*/

    .contentBox .contentHeader .header_left {
        float: left;
    }

    .contentBox .contentHeader .header_right {
        float: right;
    }

    /* .el-input__inner{
        width: 90%;
    }
     .el-textarea__inner{
         width: 90%;
         float: right;
     } */
    /* 解决element-ui的抽屉默认选中第一个的问题 */
    .el-drawer__header span:focus {
        outline: 0 !important;
    }

    /* 解决抽屉点击边框有蓝色边框的问题 */
    :focus {
        outline: 0;
    }

    .el-select {
        width: 100%;
    }

    .el-drawer__body {
        overflow: auto;
    }
</style>
